import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PlantCapacityAdapter } from './dto/plant-capacity.adapter';
import { PlantCapacityController } from './plant-capacity.controller';
import { PlantCapacity } from './plant-capacity.entity';
import { PlantCapacityService } from './plant-capacity.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([PlantCapacity]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [PlantCapacityController],
  providers: [PlantCapacityService,PlantCapacityAdapter,ApplicationExceptionHandler]
})
export class PlantCapacityModule {}
